
import "./menu";
// import "./fade";
import "./sticky";
import "./loadMore";
import "./faq";
import  "./lightbox";
import "./anchor";
import "./popup";
